// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__PageSizeSwitcher__pageSizeSwitcher__VTP2Hs{align-items:center;display:flex;gap:var(--JDS-PAGINATION-GAP,8px)}", "",{"version":3,"sources":["webpack://./../../platform/@jutro/components/components/Table/internal/PageSizeSwitcher/PageSizeSwitcher.module.css"],"names":[],"mappings":"AAAA,iDAEE,kBAAA,CADA,YAAA,CAEA,iCAAA","sourcesContent":[".pageSizeSwitcher {\n  display: flex;\n  align-items: center;\n  gap: var(--JDS-PAGINATION-GAP, 8px);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageSizeSwitcher": "jut__PageSizeSwitcher__pageSizeSwitcher__VTP2Hs"
};
export default ___CSS_LOADER_EXPORT___;
